import type { GenericServiceParameters } from "~/core/models/GenericServiceParameters.interface";
import LxcError from "~/core/models/LxcError.class";
import type { Fleet } from "~/modules/fleet/models/Fleet.interface";
import type { FleetCreationPayload } from "~/modules/fleet/models/FleetCreationPayload.interface";
import fleetService from "~/modules/fleet/services/fleet.service";

export function useCreateFleet({
  organizationCode,
}: GenericServiceParameters<void>) {
  const result = ref<Fleet>();
  const isLoading = ref(false);
  const error = ref<LxcError | null>(null);

  async function createFleet(fleet: FleetCreationPayload): Promise<void> {
    isLoading.value = true;

    const response = await fleetService.createOrganizationFleet({
      organizationCode,
      fleet,
    });

    if (LxcError.check(response)) {
      error.value = response;
      result.value = undefined;
    } else {
      error.value = null;
      result.value = response;
    }

    isLoading.value = false;
  }

  return {
    createFleet,
    result,
    error,
    isLoading,
  };
}
